import Switch from '@material-ui/core/Switch';
import React from 'react';

import { checked, root, switchBase, thumb, track } from './PlayMoneyToggle.scss';

interface Props {
  isPlayMoney: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const PlayMoneyToggle: React.FC<Props> = ({ isPlayMoney, onChange }) => (
  <Switch
    classes={{
      checked,
      root,
      switchBase,
      thumb,
      track
    }}
    checked={isPlayMoney}
    onChange={onChange}
    color="default"
  />
);

export default PlayMoneyToggle;
